import { onDelegatedEvent, tryJsonParse, viewTransition } from '../functions.js';

/**
 * Clears form errors when user starts typing on an input/select
 * 
 * Usage:
 *   <form>
 *      <clean-errors>
 *          <div class="has-error">
 *              <input class="form-control form-error">
 *          </div>
 *      </clean-errors>
 *   </form>
 */
export default class CleanErrorsElement extends HTMLElement {

    connectedCallback() {

        onDelegatedEvent('input', this, '.has-error *:is(input,select)', event => {
            let formGroup = event.target.closest('.has-error');
            
            if (formGroup) {
                formGroup.classList.remove('has-error');
                formGroup.querySelector('.error-message').remove();
            }

            event.target.classList.remove('form-error');
        });
       
    }

};

window.customElements.define('clean-errors', CleanErrorsElement);